import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css"; // Using the same CSS as TechTonics
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import BrochureForm from "../components/brochure-form";

const DoctorsBooklet = () => {
  const topRef = useRef(null);
  const [showForm, setShowForm] = useState(false);

  // Mapped the original pdfData to match the TechTonics structure
  const pdfList = [
    { id: 1, title: "Doctor Book 2024", src: "https://www.timscdrmumbai.in/wp-content/uploads/2024/08/Doctor-Book-2024-Vol-VIII.pdf", isWeb: false },
    { id: 2, title: "Doctor Book 2023", src: "https://www.timscdrmumbai.in/wp-content/uploads/2023/07/Doctor-Book-2023-Vol-VII.pdf", isWeb: false },
    { id: 3, title: "Doctor Book 2022", src: "https://timscdrmumbai.in/wp-content/uploads/2021/04/Doctor-Book-2022-Vol-VI-Final.pdf", isWeb: false },
    { id: 4, title: "Doctor Book 2021", src: "https://timscdrmumbai.in/wp-content/uploads/2021/04/Doctor-Book-2021.pdf", isWeb: false },
    { id: 5, title: "Doctor Book 2020", src: "https://timscdrmumbai.in/wp-content/uploads/2021/04/Doctor-Book-2020.pdf", isWeb: false },
    { id: 6, title: "Doctor Book 2019", src: "https://timscdrmumbai.in/wp-content/uploads/2021/04/Doctor-Book-2019.pdf", isWeb: false },
    { id: 7, title: "Doctor Book 2018", src: "https://timscdrmumbai.in/wp-content/uploads/2021/04/Doctor-Book-2018.pdf", isWeb: false },
    { id: 8, title: "Doctor Book 2017", src: "https://timscdrmumbai.in/wp-content/uploads/2021/04/Doctor-Book-2017.pdf", isWeb: false },
  ];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
  };

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="Doctor Booklet" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Doctor Booklet' }]} 
          />
        </div>

        <div className="spv-main-content">
          <aside className="spv-sidebar-modern">
            <div className="spv-sidebar-header-text">DOCTOR BOOKLET VOLUMES</div>
            
            <nav className="spv-nav-group pt-4">
              {pdfList.map((item) => (
                <button
                  key={item.id}
                  className={`spv-nav-card ${activePdf.id === item.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(item)}
                >
                  <div className="spv-card-content">
                    <img 
                      src="/images/icons/pdf.svg" 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{item.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area" key={activePdf.id}>               
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>

              {/* Desktop Full Screen Button */}
              <div className="spv-action-group">
                <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src)}>
                  Full Screen
                </button>
              </div>

              {/* Mobile Fallback Button (From previous fixes) */}
       
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Document Viewer"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
         
      <Footer />
    </>
  );
};

export default DoctorsBooklet;